// Tüm site içeriği (Türkçe) — Enasuspro® Carbon Ledger
import {
  Factory,
  Layers,
  FileSpreadsheet,
  ShieldCheck,
  Scale,
  Users,
  Calculator,
  FileCheck2,
  Globe2,
} from "lucide-react";

export const NAV = [
  { label: "Özellikler", href: "#features" },
  { label: "Süreç", href: "#process" },
  { label: "Kullanım", href: "#use-cases" },
  { label: "Fiyatlar", href: "/pricing" },
  { label: "İletişim", href: "#contact" },
];

export const HERO = {
  eyebrow: "ISO 14064 • GHG PROTOCOL • CBAM • ESRS • GRI",
  lines: ["İlk ISO 14064", "raporunu", "30 dakikada hazırla."],
  sub: "Enasuspro® Carbon Ledger; Kapsam 1-2-3 emisyonlarını, CBAM yükümlülüğünü ve ESRS/GRI açıklamalarını tek bir denetlenebilir platformda birleştirir.",
  primary: "Ücretsiz Başla",
  secondary: "Giriş",
};

export const MARQUEE = [
  "ISO 14064-3",
  "GHG PROTOCOL",
  "CBAM",
  "ESRS E1–E5",
  "GRI",
  "SBTi",
  "ISAE 3000",
  "CSRD",
];

export const STATS = [
  { value: "30dk", label: "İlk rapora kadar geçen süre" },
  { value: "3", label: "Kapsam (Scope 1 · 2 · 3)" },
  { value: "PDF+XML", label: "CBAM export formatı" },
  { value: "E1–E5", label: "ESRS + S1–S4 + G1 açıklama" },
];

export const PROCESS = [
  {
    no: "01",
    title: "Hesapla",
    text: "Faaliyet verilerini içe aktar; Kapsam 1, 2 ve 3 emisyonlarını GHG Protokolü emisyon faktörleriyle otomatik hesapla.",
  },
  {
    no: "02",
    title: "Raporla",
    text: "ESRS E1–E5, S1–S4, G1 ve GRI standart açıklamalarını üret; çeyreklik CBAM yükümlülüğünü PDF ve XML olarak dışa aktar.",
  },
  {
    no: "03",
    title: "Doğrula",
    text: "ISO 14064-3 / ISAE 3000 doğrulayıcıları için tam denetim izi (audit trail) ile bağımsız güvence sürecini hızlandır.",
  },
];

export const FEATURES = [
  {
    icon: Layers,
    title: "Kapsam 1 · 2 · 3 Hesaplama",
    text: "Doğrudan, enerji dolaylı ve değer zinciri emisyonlarını GHG Protokolü metodolojisiyle uçtan uca hesapla.",
    span: "lg:col-span-7",
  },
  {
    icon: FileSpreadsheet,
    title: "CBAM · PDF & XML Export",
    text: "Çeyreklik Sınırda Karbon Düzenleme Mekanizması yükümlülüğünü hesapla ve resmi formatta dışa aktar.",
    span: "lg:col-span-5",
  },
  {
    icon: ShieldCheck,
    title: "ESRS + GRI Açıklamaları",
    text: "ESRS E1–E5, S1–S4, G1 ve GRI standartlarını tek şablonda birleştir.",
    span: "lg:col-span-5",
  },
  {
    icon: Scale,
    title: "Global Karbon Vergisi Kıyası",
    text: "Ülke bazlı karbon fiyatlandırmalarını karşılaştır, maruziyetini öngör.",
    span: "lg:col-span-4",
  },
  {
    icon: FileCheck2,
    title: "Denetim İzi (Audit Trail)",
    text: "ISO 14064-3 / ISAE 3000 doğrulayıcıları için değişmez kayıt.",
    span: "lg:col-span-3",
  },
];

export const PORTAL = {
  eyebrow: "DANIŞMAN MÜŞTERİ PORTALI",
  title: "Tüm portföyünü tek panelden yönet.",
  text: "Danışmanlar; birden fazla müşterinin karbon hesabını, raporlama takvimini ve doğrulama durumunu tek bir merkezden izler. Rol bazlı erişim, müşteri bazlı ayrıştırma ve paylaşılabilir raporlar dahildir.",
  bullets: [
    "Çok müşterili portföy yönetimi",
    "Rol bazlı erişim ve yetkilendirme",
    "Paylaşılabilir raporlar ve görev takibi",
  ],
  image:
    "https://images.unsplash.com/photo-1672380135241-c024f7fbfa13?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const USE_CASES = [
  { icon: Factory, title: "Büyük Kuruluşlar", text: "Grup düzeyinde konsolide emisyon ve CSRD uyumu." },
  { icon: Users, title: "KOBİ'ler", text: "Tedarik zinciri talepleri için hızlı ISO 14064 raporu." },
  { icon: Calculator, title: "Danışmanlar", text: "Portföy genelinde ölçeklenebilir raporlama." },
  { icon: Globe2, title: "Doğrulayıcılar", text: "ISAE 3000 uyumlu, denetlenebilir veri seti." },
];

export const PRICING = [
  {
    name: "Başlangıç",
    price: "İhtiyaçlarınıza Yönelik",
    period: "",
    desc: "Tek tesis için temel karbon envanteri.",
    features: ["Kapsam 1 & 2 hesaplama", "1 ISO 14064 raporu", "PDF export", "E-posta destek"],
    cta: "Teklif Alınız",
    featured: false,
  },
  {
    name: "Kurumsal",
    price: "İhtiyaçlarınıza Yönelik",
    period: "",
    desc: "Çok tesisli kuruluşlar ve CBAM yükümlüleri için.",
    features: [
      "Kapsam 1 · 2 · 3",
      "CBAM PDF & XML export",
      "ESRS + GRI açıklamaları",
      "Denetim izi (audit trail)",
      "Öncelikli destek",
    ],
    cta: "Teklif Alınız",
    featured: true,
  },
  {
    name: "Danışman",
    price: "İhtiyaçlarınıza Yönelik",
    period: "",
    desc: "Ajanslar ve bağımsız danışmanlar için portföy.",
    features: ["Çok müşterili portal", "Rol bazlı erişim", "Beyaz etiket rapor", "API erişimi"],
    cta: "Teklif Alınız",
    featured: false,
  },
];

export const CONTACT = {
  email: "info@enasuspro.com",
  coaching: "coaching@enasuspro.com",
  phone: "+90 532 392 93 14",
  address: "Battal Gazi Sok. No:8/14, 34779 Ataşehir, İstanbul – Türkiye",
};

export const ENASUSPRO_URL = "https://enasuspro.com";
